var types = {
  MOBILE_GAME_DOWNLOADED_IN_ANDROID: 'mEB3q2'
, MOBILE_GAME_DOWNLOADED_IN_IOS: 'yyEfAv'
, OPEN_GAME_DOWNLOADED_QRCODE: '7nQVju'
, DOWNLOAD_MOBILE_GAME_SIMULATOR: '73UBVf'
, IOS_GAME_DOWNLOADED_IN_PC: 'UZ77nm'
, ANDROID_GAME_DOWNLOADED_IN_PC: 'I7b6na'
}

var urlUtils = require('@173js/url')

function trackEventWithKey(key, hrefOrAction, options) {
  var _jc_ping = window._jc_ping || [];
  options = options || {}

  if (options.withCurrentHref) {
    hrefOrAction = urlUtils.addParam(
      window.location.href, { action: hrefOrAction }
    )
  }

  _jc_ping.push([
    '_trackBlockClick'
  , key
  , hrefOrAction
  ])

  window._jc_ping = _jc_ping
}

var rNON_URL = /^(#|javascript:)/
  , $ = require('jquery')

module.exports = {
  trackEvent: function(eventType, href) {
    trackEventWithKey(types[eventType], href)
  }
, trackEventWithKey: trackEventWithKey
, trackPageview: function() {
    // See more: http://bi.local.17173.com/pages/viewpage.action?pageId=983282
    window._jc_ping = window._jc_ping || []
    _jc_ping.push(['_trackPageview'])
  }
, applyTrackLink: function() {
    $('body').on('mousedown', 'a[data-track-link]', function(e) {
      //TODO: DRY
      var element = $(e.currentTarget)
        , hrefOrAction = element.attr('href')
        , key = element.data('track-link')
        , trackOptions = { withCurrentHref : false }

      if (rNON_URL.test(hrefOrAction)) {
        if (!element.is('[data-track-action]')) { return }
        hrefOrAction = element.data('track-action')
        trackOptions.withCurrentHref = true
      }

      trackEventWithKey(key, hrefOrAction, trackOptions)
    })
  }
, applyTrackBlock: function() {
    $('[data-track-block]').each(function(index, blockElement) {
      blockElement = $(blockElement)
      var key = $(blockElement).data('track-block')

      blockElement.on('mousedown', 'a, .trackDiv, button', function(e) {
        var element = $(e.currentTarget)
          , hrefOrAction = element.attr('href') || element.attr('class')
          , trackOptions = { withCurrentHref : false }

        if (rNON_URL.test(hrefOrAction) || hrefOrAction.indexOf('trackDiv') != -1) {
          if (!element.is('[data-track-action]')) { return }
          hrefOrAction = element.data('track-action')
          trackOptions.withCurrentHref = true
        }

        trackEventWithKey(key, hrefOrAction, trackOptions)
      })
    })
  }
, applyBiClick: function(gameCode) {
    window._jc_ping = window._jc_ping || [];
    _jc_ping.push([ '_trackBiClick', 'g_1_'+gameCode+'_gift-follow']);
  }
, applyTrackArea: function() {
    $('[data-track-area]').each(function(index, areaElement) {
      areaElement = $(areaElement)
      var key = $(areaElement).data('track-area')

      window._jc_ping = window._jc_ping || [];
      _jc_ping.push([
       '_trackModuleArea',
        areaElement,
        key
      ]);
    })
  }
, applyBgArea:function(){
    $('[data-bg-area]').each(function(index, areaElement) {
      areaElement = $(areaElement)
      var key = $(areaElement).data('bg-area')
      window._jc_ping = window._jc_ping || [];
      _jc_ping.push([
        '_trackModule',
        areaElement,
        key
      ]);
    })
  }
}

